"use strict";
/**
 * Copyright © 2020 Johnson & Johnson
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 * http://www.apache.org/licenses/LICENSE-2.0
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */

var __createBinding = this && this.__createBinding || (Object.create ? function (o, m, k, k2) {
  if (k2 === undefined) k2 = k;
  Object.defineProperty(o, k2, {
    enumerable: true,
    get: function get() {
      return m[k];
    }
  });
} : function (o, m, k, k2) {
  if (k2 === undefined) k2 = k;
  o[k2] = m[k];
});

var __setModuleDefault = this && this.__setModuleDefault || (Object.create ? function (o, v) {
  Object.defineProperty(o, "default", {
    enumerable: true,
    value: v
  });
} : function (o, v) {
  o["default"] = v;
});

var __importStar = this && this.__importStar || function (mod) {
  if (mod && mod.__esModule) return mod;
  var result = {};
  if (mod != null) for (var k in mod) {
    if (k !== "default" && Object.hasOwnProperty.call(mod, k)) __createBinding(result, mod, k);
  }

  __setModuleDefault(result, mod);

  return result;
};

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.ifComponentSelector = exports.useComponentDisplayModeContext = exports.ComponentDisplayModeProvider = exports.ComponentDisplayMode = void 0;

var react_1 = __importStar(require("react"));

var fclasses_1 = require("@bodiless/fclasses");

var ComponentDisplayMode;

(function (ComponentDisplayMode) {
  ComponentDisplayMode[ComponentDisplayMode["ComponentSelector"] = 1] = "ComponentSelector";
  ComponentDisplayMode[ComponentDisplayMode["EditFlowContainer"] = 2] = "EditFlowContainer";
  ComponentDisplayMode[ComponentDisplayMode["StaticFlowContainer"] = 3] = "StaticFlowContainer";
})(ComponentDisplayMode || (ComponentDisplayMode = {}));

exports.ComponentDisplayMode = ComponentDisplayMode;
var defaultMode = ComponentDisplayMode.StaticFlowContainer;
var ComponentDisplayModeContext = react_1.default.createContext({
  mode: defaultMode
});

var useComponentDisplayModeContext = function useComponentDisplayModeContext() {
  return react_1.useContext(ComponentDisplayModeContext);
};

exports.useComponentDisplayModeContext = useComponentDisplayModeContext;

var ComponentDisplayModeProvider = function ComponentDisplayModeProvider(_a) {
  var children = _a.children,
      _b = _a.mode,
      mode = _b === void 0 ? defaultMode : _b;
  var contextValue = {
    mode: mode
  };
  return react_1.default.createElement(ComponentDisplayModeContext.Provider, {
    value: contextValue
  }, children);
};

exports.ComponentDisplayModeProvider = ComponentDisplayModeProvider; // eslint-disable-next-line max-len

var isComponentSelector = function isComponentSelector() {
  return useComponentDisplayModeContext().mode === ComponentDisplayMode.ComponentSelector;
};

var ifComponentSelector = fclasses_1.flowIf(isComponentSelector);
exports.ifComponentSelector = ifComponentSelector;